import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'inArray',
})
export class InArrayPipe implements PipeTransform {
    transform(array: any[], value: any): boolean {
        return array.includes(value);
    }
}
